import styled, { StyledProps } from 'styled-components/macro';

export const RadioLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export type RadioButtonStylesProps = StyledProps<{
  disabled: boolean;
}>;

export const RadioItem = styled.label`
  width: 16px;
  height: 16px;
  background: rgba(248, 248, 248, 0.3);
  border: 1px solid #D1D1D1;
  box-sizing: border-box;
  box-shadow: inset 0px 0.4px 2px rgba(0, 0, 0, 0.21);
  border-radius: 50%;
  cursor: pointer;
  transition: .2s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  pointer-events: auto;
  position: relative;
  margin-right: 7px;
  margin-bottom: 0;

  &:focus {
    outline: none;
  }

  &:hover {
    outline: none;
    border: 1px solid #D1D1D1;

    &:before {
      background: #2DADF7;
      opacity: .4;
      box-shadow: 0 0 0;
    }
  }

  &:before {
    content: '';
    width: 7px;
    height: 7px;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 0.6px 1px #007DA0;
    opacity: 0;
    transition: .2s;
  }
`;

export const RadioInput = styled.input`
  display: none;

  &:checked ~ ${RadioItem} {
    background: #0EA3F5;
    border: 1px solid #0EA3F5;
    box-shadow: 0 0 0;

    &:hover {
      border: 1px solid #0097EB;

      &:before {
        background: #fff;
        opacity: 1;
        box-shadow: 0px 0.6px 1px #007DA0;
      }
    }

    &:before {
      opacity: 1;
    }
  }

  &:disabled ~ ${RadioItem} {
    background: #E6E6E6;
    border: 1px solid #D1D1D1;
    color: #BCBCBC;
    pointer-events: none;

    &:before {
      background: #BCBCBC;
      box-shadow: 0 0 0;
    }
  }
`;
